import type { SignupMetadata } from '../services/marketing'
export type AttributionStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>
const KEY = 'planwise_signup_attribution'
const TTL = 30 * 86400000
function browserStorage(): AttributionStorage | undefined {
  try { return typeof window === 'undefined' ? undefined : window.localStorage } catch { return undefined }
}
export function readSignupAttribution(now = Date.now(), storage = browserStorage()): SignupMetadata {
  try {
    const raw = storage?.getItem(KEY); if (!raw) return {}
    const value = JSON.parse(raw)
    if (!value || typeof value.capturedAt !== 'number' || !Number.isFinite(value.capturedAt) || now < value.capturedAt || now - value.capturedAt >= TTL || typeof value.data !== 'object' || !value.data) {
      storage?.removeItem(KEY); return {}
    }
    const data: SignupMetadata = {}
    for (const [key, max] of [['signup_source', 80], ['signup_medium', 80], ['signup_campaign', 160], ['signup_referrer_host', 253]] as const) {
      const text = value.data[key]
      if (typeof text === 'string' && text.trim() && text.length <= max) {
        if (key === 'signup_referrer_host' && !/^[a-z0-9.-]+$/i.test(text)) continue
        data[key] = text
      }
    }
    return data
  } catch { return {} }
}
export function captureSignupAttribution(location: Pick<Location, 'search'>, referrer: string, now = Date.now(), storage = browserStorage()): void {
  try {
    if (readSignupAttribution(now, storage).signup_source) return
    const params = new URLSearchParams(location.search)
    const data: SignupMetadata = {}
    for (const [query, key, max] of [['utm_source', 'signup_source', 80], ['utm_medium', 'signup_medium', 80], ['utm_campaign', 'signup_campaign', 160]] as const) {
      const value = params.get(query)?.trim(); if (value && value.length <= max) data[key] = value
    }
    if (data.signup_source) data.signup_source = data.signup_source.toLowerCase()
    let host = ''
    try { host = new URL(referrer).hostname.toLowerCase() } catch { /* No valid referrer hint. */ }
    if (!data.signup_source && (host === 'producthunt.com' || host.endsWith('.producthunt.com'))) data.signup_source = 'producthunt'
    if (!data.signup_source) return
    storage?.setItem(KEY, JSON.stringify({ capturedAt: now, data }))
  } catch { /* Signup works even if browser storage is unavailable. */ }
}
export function clearSignupAttribution(storage = browserStorage()): void {
  try { storage?.removeItem(KEY) } catch { /* Browser privacy settings may disable storage. */ }
}
